import { GenericSlider } from '@components/common/carousel/generic-slider';
import { getObjectValue } from '@services/object-extensions';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { StoryCarouselItem } from './storia-carousel-item';

function StorieSuccesso({ stories }) {
  const [visibleSlideNumber, setVisibleSlideNumber] = useState(0);

  useEffect(() => {
    // ottenimento hash
    const { hash } = window.location;
    if (!(hash === '')) {
      // split sull'hash ottenendo l'hash effettivo e l'indice della slide
      const hashArray = hash.split('/');
      // ottenimento dell'hash
      const newHash = hashArray[0];
      // ottenimento dell'indice della slide
      const slideNumber = parseInt(hashArray[1], 10);
      // set della slide
      setVisibleSlideNumber(slideNumber);
      // set dell'hash
      window.location.hash = newHash;
    }
  }, []);

  const mappedSlides = stories?.map((story, index) => (
    <StoryCarouselItem
      imageUrl={story.imgUrl}
      mainTitle={story.title}
      title={story.subtitle}
      key={index.toString()}
      description={story.body}
      id={getObjectValue(story, 'service._id', '')}
      hasPdf={story.hasPdf}
      index={index}
      externalUrl={story.externalUrl}
    />
  ));

  return (
    <div className="snf-lx-components-home-storie-successo-storie-successo">
      <section id="storie-di-successo">
        <div className="p-2" />

        <div className="col-auto snf-font-18 snf-font-md-35 snf-font-w6 mainTitle">
          <Link to="/storie-successo" className="storie-successo-anchor">
            <FormattedMessage
              defaultMessage="Storie di successo"
              description="Storie di successo / Home - Title"
            />
          </Link>
        </div>
        <GenericSlider
          autoPlay
          showArrows
          currentSlideIndex={visibleSlideNumber}
          slides={mappedSlides}
          onSlideChange={setVisibleSlideNumber}
          cyclic
          id="success_stories_carousel"
        />
      </section>
    </div>
  );
}

StorieSuccesso.displayName = 'StorieSuccesso - Home';
export { StorieSuccesso };
